<template>
  <v-tabs-window-item class="ag-tab-item" :value="value">
    <slot />
  </v-tabs-window-item>
</template>

<script>
export default {
  props: {
    value: {
      type: String,
      required: true,
    },
  },
};
</script>

<style lang="scss" scoped>
@import '@/styles/tabs';
</style>
